/** Default page-size choices for main CRM list pages (Tenders, Leads, Orders, etc.). */
export const DEFAULT_LIST_PAGE_SIZE_OPTIONS = [50, 100, 200, 300, 500] as const;

export const DEFAULT_LIST_PAGE_SIZE = 50;

/** Customers list allows a smaller minimum page size. */
export const CUSTOMER_LIST_PAGE_SIZE_OPTIONS = [25, 50, 100, 200, 500] as const;
